export const ENVIROMENT = {
    PORTAL_HUBSPOT_ID: '20519396',
    CONF_2021_FORM_ID: '0dca1cf8-4a97-4209-b5b6-69f91744a759',
    FIRST_CONF_2022_FORM_ID: '892c6679-8204-4e15-afe9-8cc7887af96e',
    CONF_2022_FORM_ID: '1dc0045c-3c31-4327-8e61-ccd9b6c2aeba',
};